import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'

import smtpConfig from './Admin/Core/smtpconfig'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Trader */
import coins from './Admin/Trader/coins'
import indicators from './Admin/Trader/indicators'
import indicatorPerformance from './Admin/Trader/indicatorPerformance'
import entryRouter from './Admin/Trader/entryRouter'
import edges from './Admin/Trader/edges'
import quickGain from './Admin/Trader/quickGain'
import scriptSignal from './Admin/Trader/scriptSignal'
import fleet from './Admin/Trader/fleet'
import profitStrategies from './Admin/Trader/profitStrategies'
import positionGuardian from './Admin/Trader/positionGuardian'
import strategyDoctor from './Admin/Trader/strategyDoctor'
import rescanJobs from './Admin/Trader/rescanJobs'
import signalAutomation from './Admin/Trader/signalAutomation'
import bots from './Admin/Trader/bots'
import targets from './Admin/Trader/targets'
/* App Account */
import apiKeys from './Admin/Account/apiKeys'
/* Reports */
import reports from './Admin/Reports/reports'
/* Finance */
import finance from './Admin/Finance/finance'
/* System */
import systemConsole from './Admin/System/systemConsole'
/* Notifications */
import notifications from './notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    users,
    userTypes,
    smtpConfig,
    abilities,
    cropperUploads,
    fileUpload,
    coins,
    indicators,
    indicatorPerformance,
    entryRouter,
    edges,
    quickGain,
    scriptSignal,
    fleet,
    profitStrategies,
    positionGuardian,
    strategyDoctor,
    rescanJobs,
    signalAutomation,
    bots,
    targets,
    apiKeys,
    reports,
    finance,
    systemConsole,
    notifications,
  },
  strict: process.env.DEV,
})
